import React from 'react';
import {
  ArrayField,
  ChipField,
  DateInput,
  Filter,
  FunctionField,
  List,
  ReferenceField,
  ReferenceInput,
  SearchInput,
  SingleFieldList,
  TextField,
} from 'react-admin';
import moment from 'moment';
import { ZippityDatagrid } from '../../components';
import PriceField from '../coupons/PriceField';
import TextFieldWithPrependAppend from '../TextFieldWithPrependAppend';
import { ExpandRecord } from './ExpandServices';
import StatusChipField from './StatusChipField';
import ReferenceChild from '../../components/ReferenceChild';
import { perPage, getServiceEntity, getZ3PConfigValue } from '../../helper';
import { printCustomer } from '../customer';

const rowClickRedirect = (id, basePath) => {
  return `${basePath}/${id}/show`;
};

const ScheduledWorkFilter = (props) => (
  <Filter {...props}>
    <DateInput source="start_date" alwaysOn />
    <DateInput source="end_date" alwaysOn />
    <ReferenceInput
      source="service_vehicle_id"
      reference="service-vehicle"
      sort={{ field: 'service_vehicle_id', order: 'ASC' }}
      filter={{ is_active: true }}
      perPage={perPage}
      label={getServiceEntity()}
    >
      <ReferenceChild
        {...props}
        optionText="service_vehicle_id"
        source="service_vehicle_id"
      />
    </ReferenceInput>
    <SearchInput source="q" alwaysOn />
    <ReferenceInput reference="customer" source="customer_id" perPage={perPage}>
      <ReferenceChild
        {...props}
        optionText={(choice) => printCustomer(choice)}
        source="customer_id"
      />
    </ReferenceInput>
  </Filter>
);

const PaymentDue = (props) => {
  const isSkippingVehicle = getZ3PConfigValue('is_skipping_vehicle');
  const vehicleRelatedFields = [
    <ReferenceField source="vehicle_id" reference="vehicle" allowEmpty>
      <ChipField source="display_name" />
    </ReferenceField>,
    <TextField source="customer_tire_note" />,
  ];

  return (
    <div>
      <List
        {...props}
        title="Payment Due"
        filter={{ payment_due: true }}
        filterDefaultValues={{
          start_date: moment()
            .startOf('week')
            .format('YYYY-MM-DD'),
          end_date: moment()
            .endOf('week')
            .format('YYYY-MM-DD'),
        }}
        filters={<ScheduledWorkFilter />}
        sort={{ field: 'date', order: 'ASC' }}
        bulkActionButtons={false}
        perPage={50}
      >
        <ZippityDatagrid rowClick={rowClickRedirect} expand={<ExpandRecord />}>
          <TextField source="scheduled_work_id" />
          <TextField source="date" />
          <TextField
            source="customer_location"
            label="Service Location"
            sortable={false}
          />
          <TextField source="service_vehicle_name" />
          <ArrayField source="services" sortable={false}>
            <SingleFieldList>
              <ChipField source="short_name" />
            </SingleFieldList>
          </ArrayField>
          {!isSkippingVehicle ? vehicleRelatedFields : <></>}
          <TextField source="admin_note" />
          <StatusChipField source="status" />
          <PriceField record={{}} source="total_taxed_price_dollars" />
          <PriceField record={{}} source="amount_paid_dollars" />
          <ReferenceField
            source="payment_method_id"
            reference="payment-method"
            link={false}
          >
            <TextField source="short_description" />
          </ReferenceField>
          <TextField source="waitlist_note" />
          <ReferenceField source="customer_id" reference="customer" link="show">
            <FunctionField
              render={(record) =>
                record ? `${record.first_name} ${record.last_name}` : null
              }
            />
          </ReferenceField>
          <TextField source="customer_note" />
          <TextField source="technician_note" />
          <TextField source="customer_diagnostic_note" />
          <TextField source="customer_schedule_note" />
          <TextFieldWithPrependAppend source="tax_rate_percent" append="%" />
        </ZippityDatagrid>
      </List>
      <p>
        These appointments have been marked as finished but payment has not
        fully been collected.
      </p>
      <p>
        If the payment method is credit card online, we will automatically
        attempt to charge the credit card at 7pm on the day the service is
        complete.
      </p>
      <p>
        Otherwise, please reach out to these customers to collect payment and
        then update the Amount Paid field.
      </p>
    </div>
  );
};

export default PaymentDue;
